import { Brick, registerBrick, WorkflowObjectState, Transaction, CloudObject, Auth, User } from 'olympe';
import BCP from './DM_BCP.js';
import { BCP_WORKFLOW_STATES, getCurrentWorkflow, getLatestQualityApprover }
    from './BcpWorkflowAuthorizations';
import { executeLambda, getLogger } from "@olympeio/core";
import { getApplicationContext } from '../../common/utils/Context.js';

export default class AcceptMultipleBCPRequest extends Brick {

    /* Helper function to execute a Lambda and return its result.
    */
    async getLambdaResult($, lambdaName, bcpRequest, map) {
        // const result = await executeLambda($, lambdaName, [actionName, userKey, emailKey]);
        const result = await executeLambda($, lambdaName, [bcpRequest, map]);
        return JSON.parse(JSON.stringify(result));
    }
    // This function will execute a transaction 
    callExecuteQuery = async (t1, logger) => {
        try {
            let dbExecuteResult = await t1.execute();
            logger.info("::::: Execution Result ::::", dbExecuteResult);
        } catch (error) {
            // Handle errors during the send email process
            logger.error(`Error in accepting workflow for BCP:${error}`)
            throw new Error(`Error in accepting workflow for BCP:${error}`);
        }
    }

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} acceptBCPRequest
     * @param {*} bCPRequests
     * @param {function()} forwardEvent
     * @param {function(string)} setRequestAcceptanceStatus
     */
    async update($, [acceptBCPRequest, bCPRequests, dueDate, adminFirstIndicator], [forwardEvent, setRequestAcceptanceStatus]) {
        // Write your code here.
        // Loop over the number of BCP requests and call the lambda to accpet the individual request
        const applicationContext = getApplicationContext($);
        const logger = getLogger('AcceptMultipleBCPRequest');
        logger.info("input parameters", bCPRequests, bCPRequests?.length, typeof dueDate, typeof new Date(dueDate), adminFirstIndicator);

        const loggedInUserMail = CloudObject.get(Auth.getCurrentUser()).get(User.loginProp);
        for (const [key, bcpRequest] of Object.entries(bCPRequests)) {
            const roles = {
                businessPartner: bcpRequest.get(BCP.businessPartnerProp),
                procurementManager: bcpRequest.get(BCP.procurementManagerProp),
                ctagPerson: bcpRequest.get(BCP.technicalApplicationGroupProp),
                sqaPerson: bcpRequest.get(BCP.qualityAssuranceProp),
                qaFactoryPerson: bcpRequest.get(BCP.qaInFactoryProp),
                psPerson: bcpRequest.get(BCP.procurementSpecialistProp)
            };
            logger.info("Different Stakeholders for BCP request", roles);
            try {
                const currentState = getCurrentWorkflow(bcpRequest, $)?.get(
                    WorkflowObjectState.stateProp
                );
                if (currentState === BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE ||
                    currentState === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1 ||
                    currentState === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2) {
                    let latestApproverRole = await getLatestQualityApprover(bcpRequest, getCurrentWorkflow(bcpRequest, $));
                    logger.info("latest Approver Role", latestApproverRole, dueDate);
                    let completionDate = new Date(dueDate)
                    switch (currentState) {
                        case BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE:
                            logger.info("Non Admin :: BEFORE SETTING value of CTAG completion date", completionDate)
                            const t1 = new Transaction(true);
                            BCP.setCtagCompletionDueDate(t1, bcpRequest, completionDate);
                            this.callExecuteQuery(t1, logger)
                            break;
                        /* for non-admin case: user we need to check if the logged in user trying to accept
                        has QA in factory or SQA role, if she is SQA then we have to save the date as SQA date, 
                        else qa in factory date, if its the same user the save first as qa in factory date then in the nest staep save the 
                        SQA date
                        Admin case:in case use ticks Qa in factory them save the string "Qa in factory" in admin first column, else the other
                        if accept as SQA is chosen then save the date as SQA completeion date else Qa in factory date
                        case 2: for non admin user(if both SQA and QA in factory are same) always save QA in factory date first 
                        and then in next approval save the SQA date
                        Case 3) in case they are different persons then whoever accepts first we need to save the date accordingly */
                        case BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1:
                        case BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2:
                            if (latestApproverRole?.length > 0) {
                                if (latestApproverRole === "Accept as QA in the factory") {
                                    logger.info("Non Admin :: BEFORE SETTING value of SQA completion date", completionDate)
                                    const t1 = new Transaction(true);
                                    BCP.setSqaCompletionDueDate(t1, bcpRequest, completionDate);
                                    this.callExecuteQuery(t1, logger)
                                } else if (latestApproverRole === "Accept as SQA") {
                                    const t1 = new Transaction(true);
                                    logger.info("Non Admin:: BEFORESETTING value of QA In factory completion date", completionDate)
                                    BCP.setQaInFactoryCompletionDueDate(t1, bcpRequest, completionDate);
                                    this.callExecuteQuery(t1, logger)
                                }
                            }
                            else if (latestApproverRole == undefined || null == latestApproverRole) {
                                if (adminFirstIndicator === "Accept as QA in the factory") {
                                    const t1 = new Transaction(true);
                                    BCP.setAdminFirstQualityAcceptance(t1, bcpRequest, "Accept as QA in the factory");
                                    logger.info("Admin :: BEFORESETTING value of QA in factory completion date", completionDate)
                                    BCP.setQaInFactoryCompletionDueDate(t1, bcpRequest, completionDate);
                                    await this.callExecuteQuery(t1, logger)
                                } else if (adminFirstIndicator === "Accept as SQA") {
                                    const t1 = new Transaction(true);
                                    logger.info("Admin :: BEFORESETTING value of SQA completion date", completionDate)
                                    BCP.setAdminFirstQualityAcceptance(t1, bcpRequest, "Accept as SQA");
                                    BCP.setSqaCompletionDueDate(t1, bcpRequest, completionDate);
                                    await this.callExecuteQuery(t1, logger)
                                } else if (null === adminFirstIndicator) {
                                    logger.info("adminFirstIndicator is null")
                                    const mailRegex = new RegExp(`.*${loggedInUserMail?.toLowerCase()}`);
                                    if (roles.sqaPerson === roles.qaFactoryPerson) {
                                        if (currentState === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1) {
                                            const t1 = new Transaction(true);
                                            BCP.setQaInFactoryCompletionDueDate(t1, bcpRequest, completionDate);
                                            this.callExecuteQuery(t1, logger)
                                        } else {
                                            const t1 = new Transaction(true);
                                            BCP.setSqaCompletionDueDate(t1, bcpRequest, completionDate);
                                            this.callExecuteQuery(t1, logger)
                                        }
                                    }
                                    else if (roles.sqaPerson !== roles.qaFactoryPerson) {
                                        // This is the normal update case for non-admin
                                        if (mailRegex.test(roles.sqaPerson)) {
                                            const t1 = new Transaction(true);
                                            BCP.setSqaCompletionDueDate(t1, bcpRequest, completionDate);
                                            this.callExecuteQuery(t1, logger)
                                        } else if (mailRegex.test(roles.qaFactoryPerson)) {
                                            const t1 = new Transaction(true);
                                            BCP.setQaInFactoryCompletionDueDate(t1, bcpRequest, completionDate);
                                            this.callExecuteQuery(t1, logger)
                                        }
                                    } else {
                                        const chosenRole = applicationContext.get("adminFirstRole")
                                        if (chosenRole === "Accept as QA in the factory") {
                                            logger.info("Non Admin :: BEFORE SETTING value of SQA completion date", completionDate)
                                            const t1 = new Transaction(true);
                                            BCP.setAdminFirstQualityAcceptance(t1, bcpRequest, chosenRole);
                                            BCP.setQaInFactoryCompletionDueDate(t1, bcpRequest, completionDate);

                                            this.callExecuteQuery(t1, logger)
                                        } else if (chosenRole === "Accept as SQA") {
                                            const t1 = new Transaction(true);
                                            logger.info("Non Admin:: BEFORESETTING value of QA In factory completion date", completionDate)
                                            BCP.setAdminFirstQualityAcceptance(t1, bcpRequest, chosenRole)
                                            BCP.setSqaCompletionDueDate(t1, bcpRequest, completionDate);
                                            this.callExecuteQuery(t1, logger)
                                        }
                                    }
                                }
                            } else {
                                logger.info("Else if condition");
                            }
                            break;
                        default:
                            logger.info("In default condition");
                            break;
                    }
                }
                // For BP, PM, and other QA stakholder we need to call following method to accept
                try {
                    logger.info("::::: gonna call accept function ::::");
                    const acceptLambdaResult = await this.getLambdaResult($, acceptBCPRequest, bcpRequest, null);
                    logger.info("::::: accept Lambda execution Result ::::", acceptLambdaResult);
                    let isAcceptedOrNot = acceptLambdaResult.indexOf(true);
                    logger.info("::::: isAccepted Or Not ::::", isAcceptedOrNot);
                } catch (error) {
                    setRequestAcceptanceStatus(false)
                    // Handle errors during the send email process
                    throw new Error(`Error in accepting workflow for BCP:${error}`);
                }
            } catch (error) {
                setRequestAcceptanceStatus(false)
                // Handle errors during the send email process
                throw new Error(`Error in accepting workflow for BCP:${error}`);
            }
        }
        // Following code make selected BCP as null to reset the value
        applicationContext.set('selectedBCPs', [])
        setRequestAcceptanceStatus(true)
        forwardEvent();
    }


}

registerBrick('0197b20d30fb2c097584', AcceptMultipleBCPRequest);
